import {
  createMonitoringIcon,
  MONITORING_BADGE_STYLES,
  MONITORING_TYPES,
} from "@/constants/monitoring";
import { cn } from "@/lib/utils";

export default function SectionThree() {
  const cards = [
    {
      type: MONITORING_TYPES.KEYWORD,
      title: "Keyword Monitoring",
      description:
        "Track the topics that matter most across every channel. From national broadsheets to local radio, from news sites to social feeds—our platform captures mentions in real time so you never miss a beat.",
    },
    {
      type: MONITORING_TYPES.INFLUENCER,
      title: "Influencer Monitoring",
      description:
        "Keep tabs on the voices shaping public opinion. Add influencers by URL or upload a list, and we'll monitor their posts, engagement, and reach across Facebook, Instagram, X, TikTok, Reddit and YouTube.",
    },
    {
      type: MONITORING_TYPES.SOURCE,
      title: "Source Monitoring",
      description:
        "Subscribe directly to the media outlets you want monitored. Receive complete coverage from your chosen print publications, TV programs, radio shows, and online news sources—no keywords required.",
    },
    {
      type: MONITORING_TYPES.PULSE,
      title: "Pulse Monitoring",
      description:
        "Stay current with live engagement data. Our Pulse feature continuously updates post metrics, follower counts, and audience reactions so your insights are always fresh.",
    },
  ];

  return (
    <div className="w-full space-y-16">
      <div className="space-y-1 text-center">
        <h1 className="font-newsreader text-5xl leading-12 font-bold -tracking-wide text-neutral-950">
          What you can do with Metawhale
        </h1>
        <p className="text-2xl leading-normal font-medium tracking-normal text-neutral-800">
          Everything you need to stay ahead of the conversation.
        </p>
      </div>
      <div className="grid w-full grid-cols-1 gap-8 lg:grid-cols-2">
        {cards.map((card) => {
          const badgeColor = MONITORING_BADGE_STYLES[card.type];
          const monitoringIcon = createMonitoringIcon(
            card.type,
            "text-[16px] text-white",
          );

          return (
            <div
              key={card.type}
              className="gap-6 rounded-[20px] bg-white p-9 shadow-[0px_2px_20px_3px_#37322B1F]"
            >
              <div className="space-y-6">
                <div
                  className={cn(
                    "flex h-10 w-10 items-center justify-center rounded-[12px] p-1 text-[24px] text-white",
                    badgeColor,
                  )}
                >
                  {monitoringIcon}
                </div>
                <div className="space-y-2">
                  <h1 className="text-2xl leading-9 font-bold -tracking-wide text-neutral-950">
                    {card.title}
                  </h1>
                  <p className="text-md leading-6 font-medium tracking-normal text-neutral-700">
                    {card.description}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
